module.exports = __webpack_public_path__ + "media/images/flags/1x1/rou-5d2364b437c0547e1fc0be7c6b3d0306.svg";